import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyMail } from '../../redux/api';
import { aradugbo_icon } from "../../constants/images";


const Action = () => {
    const [status, setStatus] = useState('loading'); 
    const [errorMessage, setErrorMessage] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const mode = params.get('mode');
        const oobCode = params.get('oobCode');

        if (!mode || !oobCode) {
            setStatus('error');
            setErrorMessage('Invalid or missing parameters in the URL.');
            return;
        }

        if (mode === 'verifyEmail') {
            handleEmailVerification(oobCode);
        } else {
            setStatus('error');
            setErrorMessage('Invalid action mode.');
        }
    }, [location]);

    const handleEmailVerification = async (oobCode) => {
        try {
            console.log(oobCode)
            const response = await verifyMail({ code: oobCode });
            if (response.status === 200) {
                setStatus('success');
            } else {
                throw new Error(response.data.message || 'Verification failed.');
            }
        } catch (error) {
            setStatus('error');
            setErrorMessage(error.message || 'Failed to verify email.');
        }
    };

    const handleLoginRedirect = () => {
        navigate('/login');
    };

    return (
        <div 
            className="flex justify-center items-center min-h-screen"
            style={{ backgroundColor: '#EAECF0' }}
        >
            <div 
                className="p-8 rounded-lg shadow-lg max-w-md w-full flex flex-col justify-center items-center gap-8"
                style={{ backgroundColor: '#FCFCFD' }}
            >
                <img src={aradugbo_icon} alt="Arad" className="max-h-6 w-20" />
                {status === 'loading' && (
                    <div className="flex justify-center">
                        <svg
                            className="animate-spin h-8 w-8"
                            style={{ color: '#FC5059' }}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8 8 8 0 01-8-8z"
                            ></path>
                        </svg>
                    </div>
                )}

                {status === 'success' && (
                    <div>
                        <h2 
                            className="text-2xl font-bold mb-4"
                            style={{ color: '#2D2D2D' }}
                        >
                            Email Verified Successfully!
                        </h2>
                        <p 
                            className="mb-4"
                            style={{ color: '#425466' }}
                        >
                            Please click the link below to go to the login page.
                        </p>
                        <button
                            onClick={handleLoginRedirect}
                            className="px-4 py-2 rounded font-medium transition-colors duration-200 hover:opacity-90 w-full"
                            style={{ 
                                backgroundColor: '#FC5059', 
                                color: '#FCFCFD' 
                            }}
                        >
                            Go to Login
                        </button>
                    </div>
                )}

                {status === 'error' && (
                    <div>
                        <h2 
                            className="text-2xl font-bold mb-4"
                            style={{ color: '#E5484D' }}
                        >
                            Oops, something went wrong!
                        </h2>
                        <p 
                            className="mb-4"
                            style={{ color: '#425466' }}
                        >
                            {errorMessage}
                        </p>
                        <div className="space-y-3">
                            <button
                                onClick={handleLoginRedirect}
                                className="w-full px-4 py-2 rounded font-medium transition-colors duration-200 hover:opacity-90"
                                style={{ 
                                    backgroundColor: '#FC5059', 
                                    color: '#FCFCFD' 
                                }}
                            >
                                Go to Login
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Action